import comp from "./QuestionDetailsWrapper";
export default comp;
